import type { Ref } from 'vue';
import { ref, computed } from 'vue';

interface CountdownControls {
  startCountdown: (seconds: number, onEnd?: () => void) => void;
  stopCountdown: () => void;
  countdown: Ref<number>;
  formattedCountdown: Ref<string>;
}

export function useCountdown (): CountdownControls {
  const countdown: Ref<number> = ref(0);
  let intervalId: number | null = null;
  let onEndCallback: (() => void) | null = null;

  const startCountdown = (seconds: number, onEnd?: () => void): void => {
    stopCountdown();

    countdown.value = seconds;
    onEndCallback = onEnd || null;

    intervalId = window.setInterval(() => {
      countdown.value = parseFloat((countdown.value - 0.1).toFixed(2));
      if (countdown.value <= 0) {
        countdown.value = 0;
        if (onEndCallback) {
          const callback = onEndCallback;
          onEndCallback = null;
          callback();
        }
        stopCountdown();
      }
    }, 100);
  };

  const stopCountdown = (): void => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  const formattedCountdown: Ref<string> = computed(() => {
    const intCountdown = Math.floor(countdown.value);
    const minutes = Math.floor(intCountdown / 60);
    const seconds = intCountdown % 60;
    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  });

  return {
    startCountdown,
    stopCountdown,
    countdown,
    formattedCountdown,
  };
}